export default () => {
  const pressContactElement = document.querySelector('[data-press-contact]');
  if (pressContactElement) {
    const height = pressContactElement.clientHeight;
    pressContactElement.style.height = height + 'px';
  }
};
